export const backendUrl = process.env.REACT_APP_API_URL
export const shortUrl = process.env.REACT_APP_SHORT_URL
export const lktraderUrl = process.env.REACT_APP_TRADER_LK